import { useMemo } from "react";

import useTypedContext from "hooks/useTypedContext";
import useAacFlags from "hooks/useAacFlags";
import { STACK_MANAGE_ACCESS_TYPES } from "shared/Stack/access/useCanCreateStack";
import { hasAtLeastOneRequiredAction } from "utils/access";
import { hasSpaceManageAccess } from "utils/user";
import { SpacesContext } from "views/Account/SpacesProvider";
import { AccountContext } from "views/AccountWrapper";
import { Space } from "types/generated";

const useStackAvailableSpaces = (): Space[] => {
  const { spaces } = useTypedContext(SpacesContext);
  const { viewer } = useTypedContext(AccountContext);
  const { customAccessRoles } = useAacFlags();

  const availableSpaces = useMemo(() => {
    return spaces?.filter((space) =>
      customAccessRoles
        ? hasAtLeastOneRequiredAction(STACK_MANAGE_ACCESS_TYPES, viewer, space.id)
        : hasSpaceManageAccess(space.accessLevel)
    );
  }, [spaces, viewer, customAccessRoles]);

  return availableSpaces || [];
};

export default useStackAvailableSpaces;
